import { MailFolder } from 'owa-graph-schema';

export const enum MoveKind {
    Normal,
    SharedFolder,
}
export default (sourceFolder: MailFolder, destinationFolder: MailFolder) => {
    if (
        (sourceFolder && sourceFolder.mailboxInfo.type === 'SharedMailbox') ||
        (destinationFolder && destinationFolder.mailboxInfo.type === 'SharedMailbox')
    ) {
        return MoveKind.SharedFolder;
    }

    return MoveKind.Normal;
};
